import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { formatTextWithHtml } from "@/utils";
export const Feature = ({ feature }) => {
    return (_jsxs(Box, { display: "flex", gap: "spacing.12", children: [feature.Icon, _jsx(Box, { as: "span", whiteSpace: "wrap", dangerouslySetInnerHTML: { __html: formatTextWithHtml(feature.value) } })] }));
};
